import React, { useState, useContext, useEffect } from 'react';
import { Box, Accordion, Grid, Button } from '@mantine/core';
import ContentPaper from '../../../../components/layouts/rfs/Content';
import { Row } from 'react-bootstrap';
import { RfsContext } from '../../../../contexts/RfsContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AppLoader } from '../../../../components/common/loader';
import { MaterialContractTable } from './materialContractTable';
import moment from 'moment';
import { TableExport } from 'tabler-icons-react';
import { CSVLink } from 'react-csv';
import { roles } from '../../../../constants';
import { AuthContext } from '../../../../contexts/AuthContext';
import { sCodeStyles } from '../../../../utils/helpers';

export default function MaterialContractCode() {
  const { userRole } = useContext(AuthContext);
  const { form } = useContext(RfsContext);
  const { rfs_number } = form.rfsInformation;
  const accessors = {
    materials: 'selection_number',
    liquids: 'selection_number',
    skus: 'selection_number',
  };
  const secondaryAccessor = {
    materials: 'selection_name',
    liquids: 'selection_name',
    skus: 'selection_name',
  };
  const tertiaryAccessor = {
    materials: null,
    liquids: null,
    skus: null,
  };
  const [scopeErrors, setScopeErrors] = useState({
    errors: {},
    liquidErrors: {},
    materialErrors: {},
    productionSiteErrors: {},
  });

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);

  const [materialContract, setMaterialContract] = useState([]);

  const { fetchMaterialContract, StoreManualClosure } = useContext(RfsContext);

  useEffect(() => {
    getData(rfs_number);
  }, []);

  useEffect(() => {
    if ([roles.admin, roles.superAdmin, roles.pmo, roles.procurement].includes(userRole))
      setDisable(false);
  }, [userRole]);
  const getData = (rfs_number) => {
    setLoading(true);
    fetchMaterialContract(rfs_number).then((res) => {
      setMaterialContract(res.data.data);
      setLoading(false);
    });
  };
  const save = (payload, id, callback) => {
    StoreManualClosure(payload, id).then(() => {
      refresh(rfs_number);
      callback();
    });
  };

  const refresh = (rfs_number) => {
    fetchMaterialContract(rfs_number).then((res) => {
      setMaterialContract(res.data.data);
    });
  };

  const sort_matCont_acctoSKUs = [...materialContract].sort((a, b) => a.scope_id - b.scope_id);

  const selectedScopeFn = (data) => {
    let selectedScopeList = {};
    for (let i = 0; i < data.length; i++) {
      selectedScopeList[data[i].id] = {
        selection_number: data[i].selection_number,
        selection_name: data[i].selection_name,
      };
    }
    return selectedScopeList;
  };

  var selectedScopeList = selectedScopeFn(form.selectedScope.skus);

  const dataToExport = ({
    sla_date,
    status,
    scope_id,
    manually_closed,
    mat_code,
    mat_desc,
    finished_date,
    int_rfs_ps_sku_reference,
  }) => {
    return {
      'SKU no.': selectedScopeList[scope_id]?.selection_number,
      'SKU Desc': selectedScopeList[scope_id]?.selection_name,
      Plant: int_rfs_ps_sku_reference?.selected_plant,
      'Pack Mat Code': mat_code,
      'Pack Mat Description': mat_desc,
      'Status Change': status,
      Action:
        status === 'Closed' ? (manually_closed ? 'Manually Closed' : 'Automatic Closure') : 'NA',
      'Step Deadline': sla_date,
      'Step Finished': status === 'Closed' ? finished_date : status,
    };
  };
  const csvArray = sort_matCont_acctoSKUs.map(dataToExport);

  if (loading) {
    return (
      <ContentPaper page={'ProductDevelopment'}>
        <AppLoader size='lg' center />
      </ContentPaper>
    );
  }

  return (
    <ContentPaper page={'ProductDevelopment'}>
      <Box sx={sCodeStyles}>SKU CODES</Box>
      <div
        style={{
          display: 'flex',
          justifyContent: 'right',
          marginRight: '4rem',
        }}
      >
        <CSVLink
          data={csvArray}
          filename={'Material Contracts_' + moment().format('YYYY-MM-DD HH:mm:ss')}
        >
          <Button
            leftIcon={<TableExport />}
            color='primary'
            style={{
              marginBottom: '0rem',
              marginTop: '2rem',
              background: 'black',
            }}
          >
            Export to CSV
          </Button>
        </CSVLink>
      </div>
      <Row>
        <Accordion defaultValue={'key_0'}>
          {Object.keys(form?.selectedScope || {}).map((name) =>
            form?.selectedScope[name].map((item, index) => {
              const contractList = materialContract.findIndex((m) => m.scope_id === item.id);
              const plants = Object.values(form.scopeSelectedSkus);
              const uniquePlants = {};
              plants.forEach((p) => {
                if (p.scope_id === item.id && p.active) {
                  if (uniquePlants[p.selected_plant]) {
                    uniquePlants[p.selected_plant].plantIds.push(p.id);
                  } else {
                    uniquePlants[p.selected_plant] = { plantIds: [p.id] };
                  }
                }
              });

              return (
                contractList > -1 && (
                  <Accordion.Item
                    className='scope-label'
                    key={`key_${name}_${index}`}
                    value={`key_${name}_${index}`}
                  >
                    <Accordion.Control className={scopeErrors.errors[item.id] ? 'error-label' : ''}>
                      {`${name.substring(0, 3).toUpperCase()} -  ${item[accessors[name]]}- ${
                        item[secondaryAccessor[name]]
                      }${tertiaryAccessor[name] ? `- ${item[tertiaryAccessor[name]]}` : ''}`}
                    </Accordion.Control>
                    <Accordion.Panel>
                      {Object.keys(uniquePlants).map((plant, index) => {
                        const data = materialContract.filter((d) =>
                          uniquePlants[plant].plantIds.includes(d.sku_id),
                        );

                        return (
                          data.length > 0 && (
                            <Accordion defaultValue={'key_0'}>
                              <Accordion.Item
                                className='scope-label'
                                value={`key_${name}_${index}`}
                                key={`key_${name}_${index}`}
                              >
                                <Accordion.Control
                                  className={scopeErrors.errors[item.id] ? 'error-label' : ''}
                                >{`Plant ${plant}`}</Accordion.Control>
                                <Accordion.Panel>
                                  {
                                    <Grid>
                                      <Grid.Col span={12}>
                                        <MaterialContractTable
                                          contractData={data}
                                          save={save}
                                          disable={disable}
                                        />
                                      </Grid.Col>
                                    </Grid>
                                  }
                                </Accordion.Panel>
                              </Accordion.Item>
                            </Accordion>
                          )
                        );
                      })}
                    </Accordion.Panel>
                  </Accordion.Item>
                )
              );
            }),
          )}
        </Accordion>
      </Row>
    </ContentPaper>
  );
}
